/**
 * Training Provider branding types + label maps.
 * Strings must match DB CHECK constraints exactly.
 */

export type ProviderRoleTarget = 'technician' | 'advisor' | 'manager' | 'owner';
export type ProviderDeliveryFormat = 'live' | 'virtual' | 'on_demand';
export type ProviderTrustBadge = 'optibay_partner' | 'industry_leader' | 'community_recommended';
export type ProviderBrandingTone = 'technical' | 'leadership' | 'operational' | 'mixed';

export const PROVIDER_TRUST_BADGE_LABELS: Record<ProviderTrustBadge, string> = {
  optibay_partner: 'OptiBay Partner',
  industry_leader: 'Industry Leader',
  community_recommended: 'Community Recommended',
};

export const PROVIDER_DELIVERY_FORMAT_LABELS: Record<ProviderDeliveryFormat, string> = {
  live: 'Live Event',
  virtual: 'Virtual',
  on_demand: 'On-Demand',
};

export const PROVIDER_ROLE_TARGET_LABELS: Record<ProviderRoleTarget, string> = {
  technician: 'Technician',
  advisor: 'Advisor',
  manager: 'Manager',
  owner: 'Owner',
};

export const PROVIDER_TONE_LABELS: Record<ProviderBrandingTone, string> = {
  technical: 'Technical',
  leadership: 'Leadership',
  operational: 'Operations',
  mixed: 'Mixed',
};
